import { Button } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

interface AddItemButtonProps {
  onAddRole: () => void
  onAddProduct: () => void
}

const AddItemButton = ({ onAddRole, onAddProduct }: AddItemButtonProps) => {
  return (
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Button type="secondary" iconName="add">
          {i18n.t('finance.quotes.quote_phases_table.actions.add_item')}
        </Button>
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="center">
        <PopoverMenu.TouchableOption
          title={i18n.t('finance.quotes.quote_phases_table.actions.add_role')}
          onClick={onAddRole}
        />
        <PopoverMenu.TouchableOption
          title={i18n.t('finance.quotes.quote_phases_table.actions.add_product')}
          onClick={onAddProduct}
        />
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}

export default AddItemButton
